import { IInitialState } from 'store/models';
import { clientsStateSelector } from 'modules/admin-panel/pages/clients/selectors/clientsStateSelector';

export function clientMailingListSelector(state: IInitialState) {
	return clientsStateSelector(state).clientData?.clientCompanyMailingLists;
}
